import classNames from 'classnames';
import { FC } from 'react';

import { BlogPostInterface } from '@/src/assets/interfaces/blogPostInterface';
import { getImageUrl } from '@/src/assets/utils/getImageUrl';

import NextImage from '../../UI/nextImage/NextImage';

import styles from './BlogPostCard.module.scss';

interface BlogPostCardProps {
    post: BlogPostInterface;
}

const BlogPostCard: FC<BlogPostCardProps> = ({ post }) => {
    return (
        <article className={styles.post}>
            <a href={`/blog/${post.slug}`} className={styles.post__imageWrapperLink}>
                <NextImage
                    src={getImageUrl(post.image)}
                    fill={true}
                    alt={post.image.alt || "Post's feature image"}
                    quality={90}
                    loading="lazy"
                    sizes="(max-width: 1100px) 93vw, (max-width: 1920px) 52vw, (min-width: 1921px) 1032px"
                    className={styles.post__image}
                />
            </a>
            <div
                className={classNames(styles.post__content, {
                    [styles[`post__content--noTags`]]: !post.tags,
                })}>
                {post.tags && (
                    <div className={styles.post__tags}>
                        {post.tags?.map((tag) => {
                            return (
                                <a
                                    href={`/blog/tag/${tag.slug}`}
                                    className={styles.post__tag}
                                    key={tag._id}>
                                    {tag.title}
                                </a>
                            );
                        })}
                    </div>
                )}
                <h2 className={styles.post__title}>
                    <a className={styles.post__titleLink} href={`/blog/${post.slug}`}>
                        {post.title}
                    </a>
                </h2>
                {/* <span className={styles.post__info}>{getUpdateDate(post._updatedAt)}</span> */}
            </div>
        </article>
    );
};

export { BlogPostCard };
